import { render, staticRenderFns } from "./ConfigAccessGroupsTab.vue?vue&type=template&id=1fb1953e&scoped=true"
import script from "./ConfigAccessGroupsTab.vue?vue&type=script&lang=js"
export * from "./ConfigAccessGroupsTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigAccessGroupsTab.vue?vue&type=style&index=0&id=1fb1953e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1953e",
  null
  
)

export default component.exports